import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import MediaItem from '../../../../components/Editor/MediaEditor/MediaItem';
import { getResourceUrl, getYoutubeVideoCover, getVideoCover } from '../../utils/helpers';
import { EditableType, EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		routerParamsHistory,
		editor: {
			type: editorType,
			editableMedia,
		},
		galleryInfos: { config },
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const { page, id, canDragAndResize } = ownProps;
	const {
		type,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
	} = editableMedia[page][id];
	const link = (isExternalLinkActive ? externalLink : driveLink) || defaultLink as string;
	const isDefaultMedia = isExternalLinkActive ? externalLink === defaultLink : !driveLink;
	let src = getResourceUrl(link, config, +resourceId, editorType === EditorType.HTML);

	if (type === EditableType.video) {
		const isDefaultVideoInHtmlEditor = editorType === EditorType.HTML && isDefaultMedia;
		src = isExternalLinkActive
			? getYoutubeVideoCover(src)
			: getVideoCover(src, isDefaultVideoInHtmlEditor);
	}

	return {
		...editableMedia[page][id],
		canDragAndResize,
		editorType,
		src,
		isDefaultMedia,
	};
};

export default connect(mapStateToProps)(MediaItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/MediaEditor/MediaItem/index.tsx